export default {
  login: {
    title: 'Tabbio',
    heading: 'Welcome back',
    subtitle: 'Sign in to continue to Tabbio',
    emailPlaceholder: 'name@email.com',
    passwordPlaceholder: 'Password',
    continue: 'Continue with email',
    legalPrefix: 'By continuing, you agree to the',
    legalAnd: 'and acknowledge the',
    termsLink: 'Terms of Service',
    privacyLink: 'Privacy Policy',
    or: 'OR',
    orContinueWithEmail: 'OR CONTINUE WITH EMAIL',
    back: 'Back',
    methodTitle: 'Welcome back',
    methodSubtitle: 'We found an account for {{email}}. Choose how you want to continue.',
    continueWithPassword: 'Use password',
    continueWithOtp: 'Email me a code',
    passwordTitle: 'Enter your password',
    accountFoundTitle: 'We found your Tabbio account',
    accountFoundBody:
      'This email already has an account. Sign in and your imported CV will be added to it. Want a separate account? Choose "Use another email" above.',
    passwordSubtitle: 'Sign in with the password for this account.',
    otpTitle: 'Check your email',
    otpSubtitle: 'Enter the 6-digit sign-in code sent to {{email}}.',
    otpPlaceholder: '123456',
    verifyCode: 'Verify code',
    resendCode: 'Resend code',
    resendCodeIn: 'Resend in {{seconds}}s',
    useEmailCode: 'Use email code instead',
    signupTitle: 'Create your account',
    signupSubtitle: 'Finish setting up {{email}} with your basic details.',
    signupOtpTitle: 'Verify your email',
    signupOtpSubtitle: 'Enter the 6-digit code we sent to {{email}} to continue creating your account.',
    createAccount: 'Create account',
    useAnotherEmail: 'Use another email',
    socialError: 'Unable to continue with {{provider}} right now.',
    accountNotLinked:
      'That account already exists with a different sign-in method. Sign in the way you first registered, then connect this one from Settings › Account.',
    emailValidationError: 'Enter a valid email address.',
    emailCheckError: 'We could not check that email right now.',
    accountUnavailable: 'This account is not available for sign-in.',
    accountDeleted: 'This account has been deleted and cannot be used to sign in.',
    partnerAccountNotice:
      'You have a partner account. Manage it at partners.tabbio.com, or continue signing in here.',
    bootstrapCheckTitle: 'We need to verify your sign-in methods',
    bootstrapCheckSubtitle: 'We could not confirm your linked accounts yet. Retry before entering the app.',
    bootstrapCheckRetry: 'Retry',
    bootstrapCheckLoading: 'Checking your account…',
    bootstrapPasswordTitle: 'Create your password',
    bootstrapPasswordSubtitle: 'Add a password for {{email}} so you can sign in without a code next time.',
    bootstrapPasswordPlaceholder: 'New password',
    bootstrapPasswordConfirmPlaceholder: 'Confirm password',
    bootstrapPasswordSubmit: 'Save password',
    bootstrapPasswordMismatch: 'Passwords do not match.',
    bootstrapPasswordError: 'We could not save your password right now.',
    passwordRequired: 'Enter your password to continue.',
    passwordValidationError: 'Choose a stronger password.',
    passwordSignInError: 'We could not sign you in with that password.',
    otpSendError: 'We could not send a sign-in code right now.',
    otpRequired: 'Enter the 6-digit code we sent to your email.',
    otpSignInError: 'That code did not work. Try again or resend it.',
    otpTooManyAttempts: 'Too many attempts. Request a new code.',
    otpLocked: 'Too many verification attempts. Try again in 15 minutes.',
    otpResendCooldown: 'Please wait a moment before requesting another code.',
    nameRequired: 'Add your name to create your account.',
    usernameValidationError: 'Choose a valid username.',
    signupError: 'We could not create your account right now.',
    accountCreated: 'Account created',
    signInSuccess: 'Signed in successfully',
    authSyncRetryMessage: 'We could not finish signing you in. Please try again.',
    appleUnavailableError: 'Apple Sign-In is not available on this device.',
    appleTokenError: 'We could not read your Apple identity token.',
    continueGoogle: 'Continue with Google',
    continueApple: 'Continue with Apple',
    continueUaePass: 'Continue with UAE Pass',
    heroBase: 'Build your digital CV',
    heroAccent: 'in seconds.',
    heroSubtitle: 'Finds jobs, tailors your CV, applies for you, and tells you when employers reply.',
    moreOptions: 'More Options',
    continueEmail: 'Continue with Email',
    languageLabel: 'Language',
    languagePlaceholder: 'Select language',
    authCompleteStatus: 'Finishing sign in',
    noAccount: "Don't have an account? Sign up",
    signIn: 'Sign In',
  },

  uaePass: {
    brandName: 'Tabbio',
    signInButton: 'Sign in with UAE PASS',
    linkChoiceTitle: 'Do you have an online account with Tabbio?',
    linkChoiceTitleBeforeBrand: 'Do you have an online account \n with',
    yes: 'Yes*',
    no: 'No**',
    noteLabel: 'Note:',
    note: "This is a one time process, your future login's through UAE PASS will be seamless.",
    linkExistingHelp:
      'Your UAE PASS account will be linked to your existing Tabbio profile',
    linkCreateHelp:
      'Your Tabbio profile will be established based on the UAE PASS account',
    existingAccountRequired:
      'An existing Tabbio account already exists for this UAE PASS profile. Please choose Yes to link it.',
    linkingTitle: 'UAE PASS – Tabbio Profile Linking',
    linkingSubtitle: '(Login with your Tabbio credentials)',
    linkExistingCtaWeb: 'Link account with UAE PASS',
    linkExistingCtaNative: 'Link account with UAE PASS',
    matchingEmailRequired:
      'Please enter the same email address provided by UAE PASS to continue linking.',
    emailPlaceholder: 'yourname@email.com',
    noAccountFound: 'No Tabbio account was found for this email address.',
    checkEmailTitle: 'Check your email',
    checkEmailBody: 'We sent a 6-digit code to',
    verifyLinkCta: 'Verify & Link',
    registrationTitle: 'Complete Registration',
    registrationBody:
      'Your profile is pre-filled with verified UAE PASS data. Please complete the remaining fields below.',
    createAccountCta: 'Create Account',
    welcomeTitle: 'Welcome to Tabbio',
    welcomeBody: 'Your profile has been created with verified UAE PASS data',
    welcomeCta: 'Continue to set up your profile',
    verifiedSectionTitle: 'VERIFIED UAE PASS DATA',
    visitorBadge: 'Verified visitor',
    visitorDescription:
      'This UAE PASS profile is verified as a visitor and includes the visitor profile attributes required by UAE PASS.',
    readOnlyNote: 'UAE PASS data is read-only and cannot be edited',
    unlinkTitle: 'Unlink UAE PASS?',
    unlinkBody:
      'Your verified UAE PASS connection will be removed from this Tabbio account. You can link it again later.',
    fieldLabels: {
      fullName: 'FULL NAME',
      email: 'EMAIL ADDRESS',
      gender: 'GENDER',
      mobile: 'MOBILE NUMBER',
      nationality: 'NATIONALITY',
      profileType: 'PROFILE TYPE',
      unifiedId: 'UNIFIED ID',
    },
    errors: {
      authFailed: 'Something went wrong during the login, please try again later!',
      cancelled: 'User cancelled the login',
      sop1:
        'You are not eligible to access this service. Your account is either not upgraded or you have a visitor account. Please contact TABBIO TECHNOLOGY to access the services.',
      sop2:
        'Your UAE PASS signature is not qualified. Please upgrade your account following instructions in the UAE PASS app to obtain a Qualified Signature.',
      ineligible:
        'You are not eligible to access this service. Your account is either not upgraded or you have a visitor account. Please contact TABBIO TECHNOLOGY to access the services.',
      stateFailed: 'Something went wrong during the login, please try again later!',
      sessionExpired: 'User cancelled the login',
      alreadyLinked:
        'This UAE Pass account is already linked to another Tabbio account',
      wrongAccount:
        'Please sign in with the matched Tabbio account to link UAE PASS.',
      unlinked: 'Your UAE PASS account has been disconnected.',
      alreadyUnlinked: 'UAE PASS is already disconnected on this account.',
    },
  },

  register: {
    title: 'Create Account',
    heading: 'Create your account',
    subtitle: 'Start building your CV today.',
    namePlaceholder: 'Full Name',
    usernamePlaceholder: 'Username',
    emailPlaceholder: 'Email address',
    passwordPlaceholder: 'Password',
    signUp: 'Sign Up',
    hasAccount: 'Already have an account? Sign in',
  },

  passwordField: {
    show: 'Show password',
    hide: 'Hide password',
    rules: {
      minLength: 'At least 8 characters',
      hasLetter: 'Contains a letter',
      hasNumber: 'Contains a number',
      hasSpecial: 'Contains a special character',
    },
  },

  onboarding: {
    getStarted: 'Get Started',
    next: 'Next',
    skip: 'Skip',
    back: 'Back',
    done: 'Done',
    completing: 'Setting up…',
    language: 'Language',
    cancel: 'Cancel',
    slides: {
      webcv: {
        title: 'Your Career Identity',
        subtitle: 'One CV, one source of truth.',
      },
      aiAssistant: {
        title: 'Connected Everywhere',
        subtitle: 'Share with anyone. Reach any AI or agent.',
      },
      employers: {
        title: 'Found By The Right People',
        subtitle: 'Your CV does the reaching.',
      },
    },
    whereHeard: {
      title: 'Where Did You Hear',
      titleAccent: 'About Us?',
      promptTitle: 'Where did you hear about us?',
      promptSubtitle: 'One tap helps us reach more job seekers.',
      options: {
        appStore: 'App Store search',
        google: 'Google search',
        friend: 'Friend referral',
        social: 'Social media',
        other: 'Other',
      },
      otherPlaceholder: 'Tell us',
      socialPlatforms: {
        instagram: 'Instagram',
        linkedin: 'LinkedIn',
        tiktok: 'TikTok',
        x: 'X (Twitter)',
        youtube: 'YouTube',
        facebook: 'Facebook',
      },
    },
    whoSeesYou: {
      title: 'You decide',
      titleAccent: 'who sees you',
      subtitle: 'Your privacy, your call. Change it anytime.',
      showPhoto: 'Show my photo publicly',
      public: { title: 'Public', subtitle: 'Search engines can index your CV. Contacts stay hidden' },
      employers: { title: 'Employers only', subtitle: 'Your CV stays hidden from the public' },
      private: { title: 'Fully private', subtitle: 'Nothing shared' },
    },
    thisIsYou: {
      titleBase: 'This Is',
      titleAccent: 'You',
      subtitle: 'Your name, photo and Tabbio link',
      photoLabel: 'CV photo (optional)',
      photoSublabel: 'Only for your CV. Your account photo is separate.',
      hidePhotoPublic: 'Hide it from public',
      fullNameLabel: 'Full name',
      verifiedFullNameLabel: 'Verified full name',
      cvNameLabel: 'Name on CV',
      tabbioLinkLabel: 'Your Tabbio link',
      tabbioLinkPlaceholder: 'your-link',
      stableLinkHelper: 'Created from your CV name and kept stable for sharing.',
      linkSaveFailed: 'Could not reserve your link',
      privacyFooter: 'You choose who sees what.',
      privacyLink: 'Privacy',
      cta: 'Continue',
    },
    enrichment: {
      working: 'Updating your CV. Changes will appear here automatically.',
    },
    cvStyle: {
      triggerTitle: 'Choose CV style',
      triggerSub: 'Match your CV to your career stage',
      appliedTitle: '{{style}} selected',
      appliedSub: 'Tap to choose a different style',
      applyingTitle: 'Applying {{style}}',
      applyingSub: 'Updating your CV',
      failedSub: "Couldn't apply this style. Tap to retry.",
      sheetTitle: 'Choose CV style',
      sheetSubtitle: 'Pick the option that best fits your current career stage.',
      suggestedBadge: 'Suggested',
      useSelectedCta: 'Apply style',
      savingCta: 'Saving style…',
      saveError: "Couldn't save this CV style. Please try again.",
      loadingCta: 'Opening',
      skipCta: 'Keep current CV',
      doneToast: 'CV style applied',
      unavailableTitle: 'Style unavailable',
      unavailableBody: 'This CV style is unavailable. You can continue and change it later.',
      pickForMeTitle: 'Use recommended style',
      pickForMeSub: '{{style}} fits your profile',
      groups: {
        career: 'Career stage',
        uae: 'UAE national',
        gcc: 'GCC national',
        expat: 'Expat',
      },
      segments: {
        'career-fresh': { label: 'Career starter', desc: 'Education, internships and early strengths lead the story' },
        'career-mid': { label: 'Experienced professional', desc: 'Clear progression and measurable results lead the CV' },
        'career-managerial': { label: 'Leadership', desc: 'Team ownership, decisions and delivery scope come first' },
        'career-exec': { label: 'Executive', desc: 'Strategy, scale and organization-level impact lead the story' },
        'uae-fresh': { label: 'UAE national, Fresh graduate', desc: 'First CV with education and NAFIS fit up front' },
        'uae-mid': { label: 'UAE national, Mid-career', desc: 'Experience-led CV with clear results' },
        'uae-managerial': { label: 'UAE national, Manager', desc: 'People leadership, ownership and delivery' },
        'uae-exec': { label: 'UAE national, Executive', desc: 'Strategy, scale and senior leadership' },
        'gcc-national': { label: 'GCC national', desc: 'For Saudi, Kuwait, Qatar, Bahrain or Oman' },
        'expat-fresh': { label: 'Expat, Fresh graduate', desc: 'First Gulf CV with skills and strengths up front' },
        'expat-mid': { label: 'Expat, Mid-career', desc: 'Experience-led CV with clear results' },
        'expat-managerial': { label: 'Expat, Manager', desc: 'People leadership, ownership and delivery' },
        'expat-exec': { label: 'Expat, Executive', desc: 'Strategy, scale and senior leadership' },
      },
    },
    cvPreset: {
      triggerLabel: 'Custom CV',
      sheetTitle: 'Choose a Custom CV',
      sheetSubtitle:
        'Built by career experts and the community. Each one changes how your CV is written, section by section.',
      searchPlaceholder: 'Search custom CVs',
      searchEmpty: 'No custom CVs match that search.',
      appliedLabel: '{{preset}} applied',
      changeLabel: 'Change',
      removeLabel: 'Remove custom CV',
      applyError: "Couldn't apply this preset. Please try again.",
      presets: {
        'preset-uae-national': {
          label: 'UAE National CV',
          desc: 'For Emiratis. Opens with "UAE national" where quota systems and recruiters look.',
        },
        'preset-fresh-graduate': {
          label: 'Fresh graduate CV',
          desc: 'For new graduates entering the UAE job market.',
        },
        'preset-hr': {
          label: 'HR CV',
          desc: 'For HR professionals targeting roles across industries.',
        },
        'preset-career-switch': {
          label: 'Career switch CV',
          desc: 'For professionals transitioning to a new field or industry.',
        },
        'preset-relocate-gulf': {
          label: 'Relocate to the Gulf CV',
          desc: 'For professionals targeting new opportunities across the GCC.',
        },
      },
    },
    howToReachYou: {
      titleBase: 'How To',
      titleAccent: 'Reach You',
      subtitle: 'Only you and employers see these',
      emailLabel: 'Email',
      emailPlaceholder: 'example@gmail.com',
      emailInvalid: 'Enter a valid email address.',
      phoneLabel: 'Phone number (optional)',
      linksSection: 'Links',
      linksSublabel: 'Public on your CV',
      linkUsernameError: 'Enter your username or paste your profile link.',
      websiteError: 'Enter a website, e.g. yoursite.com',
      footerText: 'Only you and employers see these.',
      howItWorksLink: 'How it works',
      modalTitle: 'How Your Contacts Work',
      modalRow1Q: 'Who Sees Your Email & Phone?',
      modalRow1A: 'Only you and employers. Never the public',
      modalRow2Q: 'Then How Do People Reach You?',
      modalRow2A: 'They message you on Tabbio. No number needed',
      modalRow3Q: 'Can You Share Them Yourself?',
      modalRow3A: 'Yes. Send a private link anytime',
      modalDone: 'Done',
      cta: 'Continue',
    },
    whoSeesCV: {
      recommended: 'RECOMMENDED',
      titleBase: 'Who Can',
      titleAccent: 'See Your CV',
      subtitle: 'Your privacy, your call. Change it anytime',
      footerText: "You're in control. Change anytime.",
      privacyLink: 'Privacy',
      publicIndexingConsent:
        'I understand that Public creates an open Tabbio page that search engines such as Google may index. I can withdraw this choice anytime.',
      ctaLabel: 'Create CV',
    },
    basicData: {
      title: 'Add your',
      titleAccent: 'basic data',
      photoTitle: 'Profile Photo',
      photoHint: 'Add a clean, professional photo',
    },
    signOut: 'Sign out',
    notifications: {
      titleBase: 'Allow',
      titleAccent: 'notifications',
      subtitle: 'Remember, you can turn it off anytime',
      benefit1: 'Benefit no. 1 placeholder text',
      benefit2: 'Benefit no. 2 placeholder text',
      benefit3: 'Benefit no. 3 placeholder text',
      allow: 'Allow notifications',
      maybeLater: 'Maybe later',
    },
    dataSafe: {
      titleBase: 'Your data is',
      titleAccent: 'safe',
      subtitle: 'Choose how Tabbio handles your data',
      helpTitle: 'Help improve Tabbio',
      helpDesc: 'To make Tabbio better, this lets us use your data to evaluate, train and improve Tabbio’s features & AI models.',
      privacyTitle: 'Privacy mode',
      privacyDesc: 'With Privacy Mode on, none of your data is stored or used for model training by us or any third party.',
    },
    cvHealth: {
      checkingTitle: 'Checking your CV',
      reportTitle: 'CV Health',
      continue: 'Continue',
      fixMyCv: 'Fix my CV',
      tryAgain: 'Try again',
      continueWithout: 'Continue without checking',
      tryAnotherFile: 'Try another file',
      back: 'Back',
      agent: {
        fixing: 'Fixing what we found…',
        fixingContext: 'Your jobs, dates and contact details stay the same.',
        rechecking: 'Checking your new CV…',
        recheckingContext: 'Your new score is almost ready.',
        undoing: 'Putting your original text back…',
      },
      fixedUp: 'Your CV went from {{from}} to {{to}}.',
      fixedNow: 'Your CV now scores {{score}}.',
      // Fix changed nothing, or a lower result was undone: the CV keeps its score.
      alreadyScores: 'Your CV already scores {{score}}.',
      questionsLeft_one: '{{count}} thing needs your OK. Review it anytime in your CV.',
      questionsLeft_other: '{{count}} things need your OK. Review them anytime in your CV.',
      fixFailed: "We couldn't finish fixing your CV.",
    },
    chooseAI: {
      titleBase: 'Choose how far',
      titleAccent: 'you want to go',
      subtitle: 'Start free, or unlock the tools that help you apply faster and stand out.',
      proName: 'Pro',
      plusName: 'Plus',
      freeName: 'Free',
      freePrice: 'Free',
      recommended: 'RECOMMENDED',
      poweredBy: 'Best for',
      proFit: 'For automation and career power users',
      plusFit: 'For active job seekers',
      freeFit: 'For getting started',
      proFeat1: 'Everything in Plus',
      proFeat2: 'Career agent automations on your schedule',
      proFeat3: 'Finds jobs for you and preps your interviews',
      proFeat4: 'Salary insights and recruiter preview',
      proFeat5: 'Most capable AI, extended memory, 100,000 credits/mo',
      plusFeat1: 'AI CV writer, tailored CVs, and cover letters',
      plusFeat2: 'Unlimited SmartApply autofill',
      plusFeat3: 'Who viewed you, views and sources analytics',
      plusFeat4: 'Custom branding and any download format',
      plusFeat5: '10,000 AI credits/mo, premium Skills, connected apps',
      freeFeat1: 'Build, import, and manage your CV',
      freeFeat2: 'Public CV link, PDF export, 10 autofills a month',
      freeFeat3: 'At least 7 chat messages a day, plus a free image, 3 files and 5 web searches',
      freeFeat4: '1 Skill run a week, 1 Career agent preview a month',
      learnMore: 'Learn more',
      showLess: 'Show less',
      upgrade: 'Upgrade to {{name}} - {{price}}/mo',
      continueFree: 'Continue with Free',
      continueFreeLink: 'Continue with Free for now',
      cancelNote: 'Cancel anytime, no charge for free',
      saveFailedTitle: 'Could not save your choice',
      saveFailedBody: 'Please try again before continuing.',
      checkoutFailedTitle: 'Checkout failed',
      checkoutFailed: 'We could not start checkout. Please try again.',
      checkoutMissing: 'We could not confirm this checkout. Please choose a plan again.',
      checkoutNotConfirmed: 'Your subscription is still being confirmed. Please try again.',
      checkoutWrongUser: 'This checkout belongs to a different account.',
      title: 'How should we write your CV?',
      groupLabel: 'CV writing plan',
      close: 'Close',
      freeLabel: 'Free',
      freeDescription: 'Create and share your CV.',
      aiModel: 'AI model',
      perMonth: '/ month',
      writing: {
        basic: 'Basic writing',
        enhanced: 'Enhanced writing',
        advanced: 'Advanced writing',
      },
      benefits: {
        plus: {
          moreAi: 'More AI usage',
          connectTools: 'Connect your tools',
          insightsCustomization: 'Insights and more customization',
        },
        pro: {
          everythingInPlus: 'Everything in Plus',
          nova: 'Nova, your job-search agent',
          scheduled: 'Scheduled searches and more AI',
        },
      },
      seeAllFeatures: 'See all plan features',
      continueWithTier: 'Continue with {{tier}}',
      createFreeCv: 'Create my free CV',
      continueWithFree: 'Continue with Free',
      disclosurePaid: 'Auto-renews monthly. Cancel anytime.',
      disclosureFree: 'No payment details needed.',
    },
    cvInput: {
      title: 'Import your CV',
      subtitle: 'We\'ll extract your details to speed things up. You can also skip and enter everything manually.',
      uploadPdf: 'Upload PDF',
      uploadPdfDesc: 'Select a PDF file from your device',
      photoImage: 'Photo / Image',
      photoImageDesc: 'Take a photo or pick an image of your CV',
      pasteText: 'Paste Text',
      pasteTextDesc: 'Copy and paste your CV content',
      textPlaceholder: 'Paste your CV text here...',
      extract: 'Extract',
      minChars: 'Minimum 20 characters',
      pickFile: 'Choose PDF file',
      pickImage: 'Choose image',
    },
    personalInfo: {
      title: 'Personal information',
      subtitle: 'Tell us about yourself. This info will appear on your profile.',
      name: 'Full name',
      email: 'Email',
      phone: 'Phone',
      location: 'Location',
      headline: 'Professional headline',
      namePlaceholder: 'John Doe',
      emailPlaceholder: 'john@example.com',
      phonePlaceholder: '+971 50 000 0000',
      locationPlaceholder: 'Dubai, UAE',
      headlinePlaceholder: 'Senior Software Engineer',
      nameRequired: 'Name is required',
    },
    experience: {
      title: 'Work experience',
      titleBase: 'Add Your',
      titleAccent: 'Experience',
      subtitle: 'Results matter more than titles',
      jobTitle: 'Job title',
      company: 'Company',
      location: 'Location',
      startDate: 'Start date',
      endDate: 'End date',
      currentRole: 'I currently work here',
      addExperience: 'Add experience',
      remove: 'Remove',
      titlePlaceholder: 'Software Engineer',
      companyPlaceholder: 'Acme Inc.',
      locationPlaceholder: 'Dubai, UAE',
      datePlaceholder: 'MM/YYYY',
    },
    education: {
      title: 'Education',
      titleBase: 'Add Your',
      titleAccent: 'Education',
      subtitle: 'Latest degree first, always',
      institution: 'Institution',
      degree: 'Degree',
      field: 'Field of study',
      startDate: 'Start date',
      endDate: 'End date',
      addEducation: 'Add education',
      remove: 'Remove',
      institutionPlaceholder: 'University of Dubai',
      degreePlaceholder: 'Bachelor of Science',
      fieldPlaceholder: 'Computer Science',
      datePlaceholder: 'MM/YYYY',
    },
    certifications: {
      title: 'Certifications',
      titleBase: 'Add Your',
      titleAccent: 'Certifications',
      subtitle: 'Licenses and credentials you’ve earned',
      certName: 'Certification name',
      issuer: 'Issuing organization',
      issueDate: 'Issue date',
      expiryDate: 'Expiry date',
      addCertification: 'Add certification',
      remove: 'Remove',
      namePlaceholder: 'AWS Solutions Architect',
      issuerPlaceholder: 'Amazon Web Services',
      datePlaceholder: 'MM/YYYY',
    },
    skills: {
      title: 'Skills',
      titleBase: 'Add Your',
      titleAccent: 'Skills',
      subtitle: 'Suggested based on your profile',
      inputPlaceholder: 'Type a skill and press Add',
      add: 'Add',
      noSkills: 'No skills added yet',
      searchPlaceholder: 'Search roles or skills',
      sectionExperience: 'Experience',
      sectionEducation: 'Education',
      sectionCertifications: 'Licenses & Certifications',
      noLinkItems: 'Add experience or education first to link your skills.',
      otherCategory: 'Skills',
      linkTitle: 'Where did you use this?',
      roleAtCompany: '{{role}} at {{company}}',
      done: 'Done',
    },
    jobPreferences: {
      title: 'Job preferences',
      subtitle: '',
      titleBase: 'Are You',
      titleAccent: 'Open to Work?',
    },
    matchYou: {
      title: 'Help Recruiters',
      titleAccent: 'Match You',
      subtitle: "Add only what you want. You're always in control.",
      sections: {
        aboutYou: 'About You',
        locationEligibility: 'Location & Eligibility',
      },
      fields: {
        dateOfBirth: 'Date Of Birth',
        gender: 'Gender',
        nationalService: 'National Service',
        maritalStatus: 'Marital Status',
        dependents: 'Dependents',
        nationality: 'Nationality',
        residence: 'Country of residence',
        visaResidency: 'Visa / Residency',
      },
      options: {
        gender: {
          male: 'Male',
          female: 'Female',
          preferNot: 'Prefer not to say',
        },
        nationalService: {
          completed: 'Completed',
          inProgress: 'In progress',
          exempted: 'Exempted',
          notApplicable: 'Not applicable',
        },
        maritalStatus: {
          single: 'Single',
          married: 'Married',
          divorced: 'Divorced',
          widowed: 'Widowed',
        },
        dependents: {
          none: 'None',
          one: '1 child',
          two: '2 children',
          three: '3 children',
          fourPlus: '4+ children',
          soleProvider: 'Sole provider for family',
          supportingParents: 'Supporting parents/elders',
        },
        visaResidency: {
          citizen: 'Citizen',
          resident: 'Resident visa',
          workPermit: 'Work permit',
          visit: 'Visit visa',
          golden: 'Golden visa',
          student: 'Student visa',
        },
      },
      selectPlaceholder: 'Select',
      dateOfBirthPlaceholder: 'Select date',
      nationalitySearch: 'Search country',
      footerCaption: 'Visible to employers only.',
      privacy: 'Privacy',
      save: 'Save',
      saveFailed: 'Could not save. Try again.',
    },
    summary: {
      titleBase: 'Add Your',
      titleAccent: 'Summary',
      subtitle: 'Your intro. AI writes the draft.',
    },
    languages: {
      titleBase: 'Add Your',
      titleAccent: 'Languages',
      subtitle: 'Languages you speak, read and write',
    },
    highlights: {
      titleBase: 'Add Your',
      titleAccent: 'Highlights',
      subtitle: 'Your proudest career moments',
    },
    username: {
      title: 'Claim your username',
      subtitle: 'This will be your public profile link.',
      usernamePlaceholder: 'username',
      preview: 'Your profile will be at:',
      available: 'Available',
      checking: 'Checking...',
      taken: 'Already taken',
      reserved: 'Not available',
      invalidFormat: 'Invalid format',
      formatRules: 'Use letters, numbers, and hyphens. Start with a letter; end with a letter or number.',
      trySuggestion: 'Try: {{suggestion}}',
      useSuggestion: 'Use {{suggestion}}',
      checkFailed: "Couldn't check availability: you can still continue",
      tooShort: 'Must be at least 3 characters',
      invalidChars: 'Only lowercase letters and numbers',
      required: 'Pick a link to continue',
    },
    complete: {
      title: 'You\'re all set!',
      subtitle: 'Your profile is ready. Start exploring Tabbio.',
      copyLink: 'Copy link',
      linkCopied: 'Link copied',
      companySubtitle: 'Your company setup is ready. Choose your next hiring action.',
      profileLink: 'Your profile link:',
      companyLink: 'Your career page:',
      goToTabbio: 'Go to Tabbio',
      exploreTabbio: 'Find jobs',
      // The preview is not the last screen (privacy and the survey follow), so
      // its CTA promises the next step only. The dock supplies the arrow.
      continueFromPreview: 'Continue',
      continueError: 'Could not continue. Please try again.',
      downloadShort: 'Download',
      share: 'Share',
      downloadCv: 'Download CV',
      downloadingCv: 'Downloading...',
      goCreateJob: 'Finish & create job',
      goFindCandidates: 'Finish & find candidates',
    },
    reviewCv: {
      title: 'Complete my CV',
      subtitle: 'Tap any section to fill it in. Edit anytime.',
      add: 'Add',
      edit: 'Edit',
      preview: 'Preview my CV',
      groups: {
        essentials: 'Essentials',
        boost: 'Boost your profile',
        match: 'Get matched',
      },
      sections: {
        contact: { title: 'Contact & social', subtitle: 'Your phone, email and links' },
        experience: { title: 'Experience', subtitle: 'Your roles and employers' },
        education: { title: 'Education', subtitle: 'Schools and degrees' },
        skills: { title: 'Skills', subtitle: 'Add your skills' },
        summary: { title: 'Professional summary', subtitle: 'Add a short intro' },
        highlights: { title: 'Career highlights', subtitle: 'Pull your top wins' },
        certifications: { title: 'Certifications', subtitle: 'Add your certifications' },
        jobPreferences: { title: 'Job preferences', subtitle: 'Set what you’re looking for' },
      },
    },
    continue: 'Continue',
    profileSetup: {
      title: 'Set up your profile',
      subtitle: 'Pick a name. It becomes your URL.',
      nationality: 'Nationality',
      nationalityPlaceholder: 'e.g. Emirati, Indian, British',
      photoTitle: 'Profile photo',
      addPhoto: 'Add a photo',
      uploadPhoto: 'Upload photo',
      changePhoto: 'Change photo',
      removePhoto: 'Remove',
      photoUploadFailed: 'Could not upload your photo',
      saveFailedTitle: 'Could not save your profile',
      saveFailedBody: 'Please check your connection and try again.',
      authRequired: 'We could not finish your sign-in. Please sign in again.',
      networkFailed: 'Network request failed. Check your connection and try again.',
    },
    intent: {
      title: 'What brings you here?',
      subtitle: 'This shapes your experience',
      lookingForJob: 'Looking for a job',
      lookingForJobDesc: 'Build your CV and discover opportunities',
      freelancer: 'Freelancer',
      freelancerDesc: 'Find clients and showcase your services',
      company: 'Company',
      companyDesc: 'Build your career page and hire top talent',
      buildingBrand: 'Building my brand',
      buildingBrandDesc: 'Create a professional online presence',
      hiringTalent: 'Hiring talent',
      hiringTalentDesc: 'Find and recruit the best candidates',
    },
    companyInfo: {
      title: 'Company information',
      subtitle: "Set up your company's career page with basic information.",
      steps: {
        counter: '{{current}} of {{total}}',
        identityTitle: 'Create your company page',
        identitySubtitle: 'Start with the name candidates will recognize.',
        detailsTitle: 'Tell us about your team',
        detailsSubtitle: 'These details help candidates understand your company.',
        storyTitle: 'Bring your page to life',
        storySubtitle: 'Add your story now. You can refine everything later.',
      },
      companyName: 'Company name *',
      companyNamePlaceholder: 'Acme Inc.',
      careerPageUrl: 'Career page URL *',
      urlHint: 'This will be your public career page URL.',
      urlHintBeta: 'This slug is reserved now. Public company page publishing stays off during beta.',
      industry: 'Industry *',
      industryPlaceholder: 'Select industry',
      industryPickerTitle: 'Industry',
      companySize: 'Company size *',
      companySizePlaceholder: 'Select size',
      companySizePickerTitle: 'Company size',
      location: 'Location *',
      locationPlaceholder: 'e.g. Abu Dhabi or Dubai',
      locationHint: 'Where is your company headquartered?',
      website: 'Website (optional)',
      logo: 'Company logo',
      logoHint: 'Add a logo to make your page instantly recognizable.',
      uploadLogo: 'Upload logo',
      saveFailed: 'Could not save company information',
      saving: 'Saving...',
      createPage: 'Create company page',
      nextActionTitle: 'What do you want to do first?',
      nextActionSubtitle: "We'll take you there right after onboarding.",
      nextActionCreateJob: 'Create a job',
      nextActionCreateJobDesc: 'Post your first role and start collecting applicants.',
      nextActionFindCandidate: 'Find candidates',
      nextActionFindCandidateDesc: 'Browse candidate profiles and shortlist talent quickly.',
      nextActionChat: 'Go to recruiter chat',
      nextActionChatDesc: 'Use Tabbio AI to draft roles and recruiting workflows.',
    },
    hiringSetup: {
      title: 'Create your company page',
      subtitle: 'Set up your company to start hiring on Tabbio.',
    },
    cvJourney: {
      or: 'or',
      parseFailedTitle: 'Parse failed',
      resumeImportFailedTitle: 'Resume import failed',
      // A resume uploaded on the website could not be brought into the app.
      // Terminal outcomes (not found / expired / another account imported it)
      // are a calm note, never an error: the user did nothing wrong here and
      // the composer to upload again is right on this screen.
      handoffUnavailableTitle: 'Upload your CV again',
      handoffUnavailableBody:
        "Your CV from the website didn't carry over. Upload or paste it below to continue.",
      handoffAlreadyClaimedBody:
        'That CV has already been imported. Upload or paste a CV below to continue.',
      // Any other failure (the server could not be reached, an unknown code):
      // shown in place of the server's English message.
      handoffClaimFailedBody:
        "We couldn't bring your CV over from the website. Upload or paste it below to continue.",
      cvHandoffClaimFailedTitle: 'Could not open the CV you were sent',
      // Shown only when the failure carries no recognized reason (offline, a
      // 5xx): the invite is kept, so completion returns to it. A known reason
      // (expired / wrong email / already yours) renders its own copy from
      // seeker.cv.handoff instead.
      cvHandoffClaimFailedBody:
        'We could not reach the CV you were sent. You can keep building your CV below, and we will try the invite again when you finish.',
      // The claim committed but the profile it was meant to fill did not get
      // written, so onboarding continues normally instead of previewing a CV
      // that is not there.
      cvHandoffProfileNotUpdatedBody:
        'The CV you were sent is saved to your account. We could not fill your profile from it, so build your CV below and the saved copy will be waiting.',
      aiInputTitle: "Let's Build Your CV",
      aiInputSubtitle: 'It only takes seconds.',
      pasteHere: 'Upload or paste your CV, or just tell us what you do',
      // A pasted link alone: nothing opens links, so there is nothing to read.
      linkUnsupported: "We can't open links. Upload your CV, or copy your profile's text and paste it here.",
      extract: 'Extract with AI',
      fillManually: 'Build my CV manually',
      hiringLink: 'Hiring? Create a company page instead',
      parseFailed: 'Could not process your input. Try again or fill manually.',
      moreDetailRequired: 'Please provide more detail',
      unsupportedFile: 'That file type is not supported. Upload a PDF, Word, text, or image file.',
      fileTextUnreadable:
        "We couldn't read enough text from this file. Try a text-based PDF or Word document, or paste the resume text.",
      // Recoverable import outcomes (incident 2026-09-02): the parse held no
      // CV body or the AI provider was unavailable. Nothing was written.
      parseIncomplete:
        "We couldn't find work experience, education, or certifications in this CV, so nothing was changed. Try another file or paste the CV text.",
      parseIncompleteReview:
        "We couldn't read every section of this CV, so nothing was changed. The text we could read is below: review it, add anything missing, and extract again.",
      parseProviderUnavailable:
        'Our CV reader is temporarily unavailable, so nothing was changed. Please try again in a few minutes, or paste the CV text.',
      handoffRetryLater:
        'Your uploaded CV is kept for a short while. Try again in a few minutes, or upload it below.',
      // Review step before an import parsed WITHOUT AI replaces anything.
      exactExtractionTitle: 'Imported without AI',
      exactExtractionMessage:
        'Our AI writer was unavailable, so we used the exact details from your CV without rewriting them. You can review and improve them in the next steps.',
      exactExtractionContinue: 'Use exact details',
      exactExtractionCancel: 'Not now',
      parseProgress: {
        reading: {
          title: 'Reading your CV',
          detail: 'Finding roles, education, and contact details.',
        },
        extracting: {
          title: 'Extracting experience',
          detail: 'Turning work history into structured profile sections.',
        },
        enhancing: {
          title: 'Improving the wording',
          detail: 'Sharpening summary, skills, and highlights.',
        },
        preparing: {
          title: 'Preparing your CV',
          detail: 'Getting the next review step ready.',
        },
      },
      headerTitle: 'Contact & Social',
      headerSubtitle: 'How can people reach you?',
      headerTitleBase: 'Add your',
      headerTitleAccent: 'CV Contacts',
      addressLabel: 'Address',
      linksSection: 'Links',
      tabbioLinkLabel: 'Tabbio Link',
      contactSection: 'CV contact',
      accountEmailLabel: 'Account email',
      accountEmailUnavailable: 'Not available',
      accountEmailHelper: 'This is the email you use to sign in. It stays private and cannot be edited here.',
      cvEmailLabel: 'Email',
      cvEmailPlaceholder: 'email@example.com',
      cvEmailHelper: 'Use this email on your CV if you want people to contact you there. Leave it blank to hide an email from your CV.',
      phoneLabel: 'Phone number',
      phoneRequired: 'Phone number is required.',
      phoneInvalid: 'Enter a valid phone number for the selected country.',
      links: 'Links',
      emailVisibilityTitle: 'Who can see your email',
      phoneVisibilityTitle: 'Who can see your phone',
      learnVisibility: 'Learn how visibility works',
      contactVisibility: {
        recommended: 'RECOMMENDED',
        employers: { title: 'Employers only', subtitle: 'Included when you download or send your CV' },
        hidden: { title: 'Fully hidden', subtitle: 'Never shown to anyone' },
        box: {
          bothEmployers: 'Only you & employers can see your email & phone',
          bothHidden: 'Your email & phone are hidden from everyone',
          mixed: 'Your email & phone have different visibility',
        },
      },
      howContacts: {
        title: 'How your contacts work',
        subtitle: 'Super simple. You stay in control',
        private: { title: 'Private by default', desc: 'Your email & phone never show on your public CV. Only you and employers can see them. Anyone else can reach you through a Tabbio message.' },
        link: { title: 'Shared with a private link', desc: 'Send one unique link that carries your contacts, just like a normal CV. Regenerate it anytime and the old link instantly stops working.' },
        download: { title: 'Download as a PDF', desc: 'Export your CV as a PDF and share it anywhere. Your contact details are included, like any normal CV.' },
      },
    },
    visibility: {
      public: 'Public',
      employers: 'Employers',
      private: 'Private',
      hidden: 'Hidden',
      pickHint: 'Pick who can see it',
      done: 'Done',
      whoSeesYouTitle: 'Who can see you',
    },
  },

  roleSelect: {
    title: 'I am a...',
    seeker: {
      title: 'Job Seeker',
      description: 'Build your CV and find opportunities',
    },
    employer: {
      title: 'Employer',
      description: 'Find and hire the best talent',
    },
  },

  forgotPassword: {
    link: 'Forgot password?',
    title: 'Reset your password',
    subtitle: "We'll send a password reset link to your email address.",
    emailPlaceholder: 'Email address',
    invalidEmail: 'Enter a valid email address.',
    sendLink: 'Send reset link',
    sendError: 'We could not send a reset link right now.',
    sentTitle: 'Check your email',
    sentSubtitle: "We've sent a password reset link to {{email}}. Check your inbox and follow the link to reset your password.",
    resend: 'Resend link',
    resendIn: 'Resend in {{seconds}}s',
  },

  resetPassword: {
    title: 'Choose a new password',
    subtitle: 'Enter your new password below.',
    newPasswordPlaceholder: 'New password',
    confirmPasswordPlaceholder: 'Confirm new password',
    reset: 'Reset password',
    mismatch: 'Passwords do not match.',
    invalidToken: 'This reset link is invalid or has expired. Please request a new one.',
    error: 'We could not reset your password right now.',
    successTitle: 'Password reset',
    successSubtitle: 'Your password has been updated. You can now sign in with your new password.',
    backToLogin: 'Back to sign in',
  },

  profileSetup: {
    nameTitle: "What's your name?",
    nameSubtitle: 'This is how others will see you on Tabbio.',
    namePlaceholder: 'Full Name',
    nameRequired: 'We need your name to get started.',
    usernameTitle: 'Choose a username',
    usernameSubtitle: 'This will be your unique link on Tabbio.',
    usernamePlaceholder: 'username',
    usernameInvalid: 'Only lowercase letters and numbers, 3–30 characters.',
    passwordTitle: 'Set a password',
    passwordSubtitle: 'Choose a strong password to secure your account.',
    socialLinks: 'Social links',
    add: 'Add',
    continue: 'Continue',
  },
} as const;
